import React, { useState, useEffect, useContext } from "react";
import { Images } from "../../theme";
import { DotsLoader, Footer, Header, LoginHeader } from "../../components";
import { GlobalContext } from "../../context/GlobalContext";
import IconCard from "./IconCard";
import Gallery from "./Gallery";
import RentalReview from "./RentalReview";
import SignUpEmail from "../Auth/SignUpEmail";
import { Link, useNavigate } from "react-router-dom";
import Typewriter from "typewriter-effect";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import Tooltip from "@material-ui/core/Tooltip";
import { useTranslation } from "react-i18next";
import "./styles.css";

export default (props) => {
  const { t } = useTranslation();
  const getcategory = useContext(GlobalContext);
  let {
    get_categories,
    imageUrl,
    isLoading,
    categoryData,
    searchText,
    renderSearch,
    user_data,
    loginData,
    get_tax_amount,
  } = getcategory;
  let navigate = useNavigate();

  const [categoryModal, setCategoryModal] = useState(false);
  const [isActiveLogin, setIsActiveLogin] = useState(false);

  useEffect(() => {
    user_data();
    get_categories();
    get_tax_amount();
  }, []);

  const checkValidation = () => {
    if (searchText) {
      // /search
      navigate("/searchbycategory");
    }
  };

  return (
    <>
      <div>
        <div className="camera-main">
          {loginData?.id ? (
            <Header />
          ) : (
            <LoginHeader
              loginIsActive={isActiveLogin}
              setIsActiveLogin={setIsActiveLogin}
              white={true}
            />
          )}

          <div className="container my-5 py-5">
            <p className="mb-0 dashboard_heading">
              {t("Rent")}{" "}
              <label className="dashboard_heading" style={{ color: "#005494" }}>
                <Typewriter
                  className="color-blue"
                  options={{
                    strings: [
                      t("Drones"),
                      t("Electronics"),
                      t("Storage"),
                      t("Fashion"),
                      t("AV_Equipment"),
                      t("Cameras"),
                      t("Instruments"),
                      t("Sporting_Gear"),
                      t("Clothing"),
                      t("Anything"),
                      t("Everything"),
                    ],
                    autoStart: true,
                    loop: true,
                    deleteSpeed: 100,
                  }}
                />
              </label>
            </p>

            <p className="mb-0 dashboard_heading">
              {t("From")}{" "}
              <label className="dashboard_heading" style={{ color: "#005494" }}>
                <Typewriter
                  className="color-blue"
                  options={{
                    strings: [
                      t("People"),
                      t("Neighbours"),
                      t("Friends"),
                      t("Family"),
                      t("Teachers"),
                      t("Couples"),
                      t("Athletes"),
                      t("Risk_Takers"),
                      t("Your_Ex"),
                      t("Parents"),
                      t("Anyone"),
                      t("Everyone"),
                    ],
                    autoStart: true,
                    loop: true,
                    deleteSpeed: 100,
                  }}
                />
              </label>{" "}
            </p>

            <p className="mb-0 dashboard_heading"> {t("Your_Community")}</p>
            <p className="mt-2 dashboard-sub" style={{ fontSize: 22 }}>
              {t("Enjoy1")}
              <br />
              {t("Enjoy2")}
            </p>
            <div style={{ width: "40%" }} class="input-slider input-group mb-3">
              <input
                style={{ background: "#fff" }}
                type="text"
                class="form-control Montserrat MontserratSearch"
                placeholder={t("Search_Here")}
                aria-label="Recipient's username"
                aria-describedby="basic-addon2"
                value={searchText}
                onChange={(e) => renderSearch(e.target.value)}
              />
              <Tooltip
                title={searchText.length ? t("Search") : t("Please_Type_Some")}
              >
                <div class="input-group-append">
                  <button
                    class="bttn btn btn-outline-secondary"
                    type="button"
                    onClick={() => checkValidation()}
                  >
                    {t("Search")}
                  </button>
                </div>
              </Tooltip>
            </div>
            <div className="d-flex">
              <p
                style={{
                  margin: "10px 15px",
                  color: "#005494",
                  fontWeight: 600,
                }}
              >
                {t("Or")}
              </p>
              <button
                onClick={() =>
                  loginData.id
                    ? navigate("/Listanitem")
                    : setIsActiveLogin(true)
                }
                type="button"
                class="btn-list btn btn-outline-primary listanItemBtn"
              >
                {t("List_An_Item")}
              </button>
            </div>
          </div>
        </div>

        <img className="camera_image" src={Images.camera_image} alt="image" />

        <IconCard
          listAnItem={() =>
            loginData.id ? navigate("/Listanitem") : setIsActiveLogin(true)
          }
        />
        {isLoading ? (
          <DotsLoader />
        ) : (
          <Gallery
            categoryModal={categoryModal}
            setCategoryModal={setCategoryModal}
            categoryData={categoryData}
            imageUrl={imageUrl}
          />
        )}
        <RentalReview />
        <SignUpEmail />
        <Footer />
      </div>
      <Modal
        classNames={{ modal: "listcategoryModal" }}
        open={categoryModal}
        onClose={() => setCategoryModal(false)}
        center
      >
        <div>
          <p class="text-center category-txt poppins mt-4 mb-5">
            {t("Categories")}
          </p>
        </div>
        <div className="row m-0">
          {categoryData?.map((val) => {
            return (
              <Link
                className="cat-width"
                to="/searchbycategory"
                state={{ data: val }}
              >
                <div className="text-center ">
                  <img width={50} src={`${imageUrl}${val?.iconPath}`} />
                  {/* <img src={Images.cameraVis} /> */}
                  <p className="cat-pop">{val.name}</p>
                </div>
              </Link>
            );
          })}
        </div>
      </Modal>
    </>
  );
};
